import { iframeLogin } from "@/api/user";
import { getUuid, setUuid, setToken } from "@/utils/auth";
// import router from '@/router';
import { jusIframe } from "./jusIframe";

export default {
    getIframe() {
        return new Promise((resolve, reject) => {
            if (jusIframe()) {
                const params = new URLSearchParams(window.location.search);
                const appid = params.get('appid'); // 应用唯一标识符
                const uuid = params.get('uuid');   // 用户/设备唯一标识
                const timestamp = params.get('timestamp'); // 时间戳
                const sign = params.get('sign'); // 基于 HMAC-SHA256 的请求签名
                if (appid && uuid && timestamp && sign) {
                    // 判断uuid是否已经存在
                    if (uuid != getUuid()) {
                        return this.getToken({ 'appid': appid, 'uuid': uuid, 'timestamp': timestamp, 'sign': sign }).then(resolve).catch(reject);
                    }
                    resolve();
                } else {
                    reject({ 'message': '参数缺失' });
                }
            } else {
                resolve();
            }
        })
    },
    getToken(value) {
        return new Promise((resolve, reject) => {
            iframeLogin(value).then(res => {
                setUuid(value.uuid)
                setToken(res.data.token)
                resolve(res.data.token)
            }).catch(err => {
                reject(err)
            })
        })
    }
}